import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { DeviceClient } from '@frontend/device/api';
import { Device, DeviceQueryParams } from '@frontend/device/types';
import { useAccountRepository } from '@frontend/repository';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const ID = 'device-select';
export const DeviceSelectV2 = (props: ObjectSelectProps<Device, DeviceQueryParams>) => {
    const { iotId } = useParams();
    const [v, cV] = useState<Device | null>(null);
    const { currentAccount } = useAccountRepository();

    return (
        <ObjectSelectInput<Device, DeviceQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Device'}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            value={v}
            idValue={props.isClearable ? props.value : v?.id}
            fetch={(arg) => DeviceClient.fetchDevices({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(device) => device.name}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'device',
                          fetch: (pathParam) => DeviceClient.fetchDevice(currentAccount, iotId!, pathParam)
                      }
                    : undefined
            }
        />
    );
};
